var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.74219 2.55399C4.74219 1.14346 5.88565 0 7.29618 0H76.6188C78.0294 0 79.1728 1.14346 79.1728 2.55399V42.6881C79.1728 44.0987 78.0294 45.2421 76.6188 45.2421H7.29618C5.88565 45.2421 4.74219 44.0987 4.74219 42.6881V2.55399ZM32.9727 28.1094C31.3158 28.1094 29.9727 29.4525 29.9727 31.1094V38.1094C29.9727 39.7662 31.3158 41.1094 32.9727 41.1094H61.9727C63.6295 41.1094 64.9727 39.7662 64.9727 38.1094V31.1094C64.9727 29.4525 63.6295 28.1094 61.9727 28.1094H47.9727H32.9727Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 42.6888C0 40.2708 1.96022 38.3105 4.37827 38.3105H79.5386C81.9567 38.3105 83.9169 40.2708 83.9169 42.6888V58.7425C83.9169 61.1605 81.9567 63.1208 79.5386 63.1208H4.37827C1.96022 63.1208 0 61.1605 0 58.7425V42.6888ZM8.75655 47.0671V54.3642H75.1603V47.0671H8.75655Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1096 55.018C29.1664 56.2895 29.803 58.9876 28.5316 61.0444L16.1265 81.1114C14.855 83.1682 12.1569 83.8048 10.1001 82.5334C8.04334 81.2619 7.40672 78.5638 8.67818 76.507L21.0833 56.44C22.3548 54.3832 25.0528 53.7466 27.1096 55.018Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1039 54.9997C54.037 56.2546 53.3787 58.9475 54.6336 61.0144L67.0388 81.4464C68.2937 83.5133 70.9866 84.1715 73.0535 82.9166C75.1204 81.6617 75.7787 78.9688 74.5237 76.9019L62.1186 56.47C60.8637 54.403 58.1708 53.7448 56.1039 54.9997Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClass);
export default __webpack_public_path__ + "static/media/Class.59021e243055cdeaf12ed3e46d49aec0.svg";
export { ForwardRef as ReactComponent };